import { render, staticRenderFns } from "./CommonNav.vue?vue&type=template&id=85c24082&scoped=true"
import script from "./CommonNav.vue?vue&type=script&lang=js"
export * from "./CommonNav.vue?vue&type=script&lang=js"
import style0 from "./CommonNav.vue?vue&type=style&index=0&id=85c24082&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c24082",
  null
  
)

export default component.exports